<template>
  <div
    class="i-tooltip-outer-text text-no-wrap"
    v-tooltip="{
      ref: 'queryIssuePriceToolTipContent',
      class: 'vue-tooltip-query-issue-price'
    }"
  >
    <strong>{{
      $filters.currency(
        displayAmount(
          issue.requestedCreditAmountProductExTax || 0,
          issue.requestedCreditAmountProductIncTax || 0
        )
      )
    }}</strong>
    <v-icon class="mb-1" color="primary" x-small
      >mdi-help-circle-outline</v-icon
    >
    <div ref="queryIssuePriceToolTipContent">
      <table style="width: 100%">
        <tbody>
          <tr v-if="isVariableWeight">
            <td style="width: 75%"><strong>Price per KG (ex Tax):</strong></td>
            <td style="width: 25%; text-align: right">
              {{
                $filters.currency(
                  issue.supplierOrderItem.summary.costPerKgExTax,
                  '-',
                  2,
                  6
                )
              }}
            </td>
          </tr>
          <tr v-else>
            <td style="width: 75%"><strong>Carton Price (ex Tax):</strong></td>
            <td style="width: 25%; text-align: right">
              {{
                $filters.currency(
                  issue.supplierOrderItem.summary.cartonCostExTax
                )
              }}
            </td>
          </tr>
          <tr v-if="isVariableWeight">
            <td><strong>Credit Quantity (KG):</strong></td>
            <td style="text-align: right">{{ issue.disputedWeightInKg }}</td>
          </tr>
          <tr v-else>
            <td><strong>Credit Carton Quantity:</strong></td>
            <td style="text-align: right">{{ issue.disputedQuantity }}</td>
          </tr>
          <tr>
            <td><strong>Product Credit (ex Tax):</strong></td>
            <td style="text-align: right">
              {{ $filters.currency(issue.requestedCreditAmountProductExTax) }}
            </td>
          </tr>
          <tr v-if="tenantCountryRegion !== 'US'">
            <td>
              <strong>{{ totalTaxLabel }}:</strong>
            </td>
            <td style="text-align: right">
              {{ $filters.currency(issue.requestedCreditAmountProductTax) }}
            </td>
          </tr>
          <tr>
            <td>
              <strong>Product Credit{{ incTaxSuffix }}:</strong>
            </td>
            <td style="text-align: right">
              {{
                $filters.currency(
                  displayAmount(
                    issue.requestedCreditAmountProductExTax,
                    issue.requestedCreditAmountProductIncTax
                  )
                )
              }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { buildCountryDisplayRules } from '@/utils/countryDisplay'
import { pickSupplierAmount } from '@/utils/supplierAmountDisplay'

export default {
  props: {
    issue: {
      type: Object,
      required: true
    },
    isVariableWeight: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('tenant', ['tenantCountryRegion', 'tenantTaxRegime']),
    displayRules() {
      return buildCountryDisplayRules(
        this.tenantCountryRegion,
        this.tenantTaxRegime
      )
    },
    totalTaxLabel() {
      return this.displayRules.showWet
        ? `${this.displayRules.primaryTaxLabel} & ${this.displayRules.wetLabel}`
        : this.displayRules.primaryTaxLabel
    },
    incTaxSuffix() {
      return this.tenantCountryRegion === 'US' ? '' : ' (inc Tax)'
    }
  },
  methods: {
    displayAmount(exTax, incTax) {
      return pickSupplierAmount({
        tenantCountryRegion: this.tenantCountryRegion,
        exTax,
        incTax
      })
    }
  }
}
</script>
<style lang="scss">
.vue-tooltip-query-issue-price {
  min-width: 300px !important;
  width: 300px !important;

  table {
    td {
      padding: 2px 0;
    }
  }
}

@media only screen and (min-width: 400px) {
  .vue-tooltip-query-issue-price {
    min-width: 210px !important;
  }
}
</style>
